<template>
	<div class="index">
		<div class="custom-tabbar-page">
			<div class="message">
				<div class="page-header">
					<div class="header-bg">
						<div class="header-title">
							🎬 {{ $t('choose.popular_movies') }}
						</div>
						<div class="header-subtitle">
							{{ $t('choose.popular_movies_subtitle') }}
						</div>
					</div>
				</div>

				<div class="movie-recommend">
					<div class="section-header">
						<div class="header-line left"></div>
						<div class="header-content">
							<div class="section-icon">🔥</div>
							<div class="section-title">{{ $t('choose.coming_soon') }}</div>
						</div>
						<div class="header-line right"></div>
					</div>
					<div class="movie-grid">
						<div v-for="item in visibleProductList" :key="item.id" class="movie-item" @click="toTask(item.id)">
							<div class="movie-card">
								<div class="movie-poster">
									<img :src="getAssetUrl(item.img)" :alt="item.name || 'product'" />
								</div>
								<div class="movie-info">
									<div class="movie-name">{{ item.name }}</div>
									<div class="movie-meta">
										<div class="meta-tag">{{ $t('choose.support') }}</div>
										<div class="meta-hot">🔥 {{ $t('choose.popular') }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="showLoadMore" class="load-more-row" @click="loadMoreProducts">
						<div class="load-more-text">
							{{ $t('choose.view_more') }}
						</div>
					</div>
				</div>

				<div class="tn-tabbar-height"></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				productList: [],
				visibleCount: 8
			};
		},
		computed: {
			visibleProductList() {
				return this.productList.slice(0, this.visibleCount);
			},
			showLoadMore() {
				return this.visibleCount < this.productList.length;
			}
		},
		methods: {
			getAssetUrl(url) {
				if (!url) {
					return '';
				}

				if (/^https?:\/\//i.test(url)) {
					return url;
				}

				return `https://shuadan-2.0.qpl-005.site${url}`;
			},
			getProductList() {
				this.$http({
					method: "get",
					url: "productList"
				}).then((res) => {
					this.productList = Array.isArray(res.data) ? res.data : [];
					this.visibleCount = 8;
				});
			},
			loadMoreProducts() {
				this.visibleCount = Math.min(this.visibleCount + 8, this.productList.length);
			},
			toTask(productId) {
				if (!productId) {
					return;
				}

				this.$router.push({
					path: "/Task",
					query: {
						productId: productId
					}
				});
			},
		},
		created() {
			this.getProductList();
		},
	};
</script>

<style lang="less" scoped>
	.index {
		width: 100%;
		height: 100vh;
		position: relative;
		background-color: #f2f2f2;
	}

	.index .custom-tabbar-page {
		width: 100%;
		height: calc(100vh - 62px);
		box-sizing: border-box;
		padding-bottom: 0px;
		padding-bottom: calc(0px + constant(safe-area-inset-bottom));
		padding-bottom: calc(0px + env(safe-area-inset-bottom));
	}

	.message {
		background: linear-gradient(180deg, #f8f9fa, #f2f2f5);
		z-index: 1;
		min-height: 100vh
	}

	/* 底部安全边距 start*/
	.tn-tabbar-height {
		min-height: 31px;
		height: calc(31px + env(safe-area-inset-bottom) / 2);
		height: calc(31px + constant(safe-area-inset-bottom))
	}

	/* 页面头部 */
	.page-header {
		padding: 10px 15px
	}

	.page-header .header-bg {
		background: linear-gradient(135deg, #667eea, #764ba2);
		border-radius: 12px;
		padding: 26px 20px;
		text-align: center;
		box-shadow: 0 4px 15px rgba(102, 126, 234, .3)
	}

	.page-header .header-bg .header-title {
		display: block;
		font-size: 22px;
		font-weight: 700;
		color: #fff;
		margin-bottom: 6px;
		letter-spacing: 2px
	}

	.page-header .header-bg .header-subtitle {
		display: block;
		font-size: 12px;
		color: hsla(0, 0%, 100%, .85);
		letter-spacing: 1px
	}

	/* 电影推荐样式 */
	.movie-recommend {
		background: linear-gradient(135deg, #fff, #f8f9fa);
		margin: 10px;
		padding: 20px 15px;
		border-radius: 12px;
		box-shadow: 0 4px 15px rgba(0, 0, 0, .06);
		border: 0.5px solid rgba(102, 126, 234, .08)
	}

	.movie-recommend .section-header {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 20px
	}

	.movie-recommend .section-header .header-line {
		flex: 1;
		height: 1px;
		max-width: 41px
	}

	.movie-recommend .section-header .header-line.left {
		background: linear-gradient(90deg, transparent, #667eea)
	}

	.movie-recommend .section-header .header-line.right {
		background: linear-gradient(270deg, transparent, #667eea)
	}

	.movie-recommend .section-header .header-content {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0 12px
	}

	.movie-recommend .section-header .header-content .section-icon {
		font-size: 18px;
		margin-right: 6px
	}

	.movie-recommend .section-header .header-content .section-title {
		font-size: 17px;
		font-weight: 700;
		color: #333;
		letter-spacing: 2px
	}

	.movie-recommend .movie-grid {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		box-sizing: border-box
	}

	.movie-recommend .movie-grid .movie-item {
		width: 50%;
		min-width: 0;
		padding: 0 7px 15px;
		box-sizing: border-box;
		-webkit-animation: fadeInUp-data-v-1d8d274c .6s ease forwards;
		animation: fadeInUp-data-v-1d8d274c .6s ease forwards;
		opacity: 0;
		-webkit-transform: translateY(15px);
		transform: translateY(15px)
	}

	.movie-recommend .movie-grid .movie-item .movie-card {
		display: flex;
		flex-direction: column;
		background: #fff;
		border-radius: 10px;
		overflow: hidden;
		min-width: 0;
		box-shadow: 4px 4px 10px rgba(0, 0, 0, .08), -2px -2px 6px hsla(0, 0%, 100%, .8);
		transition: all .3s ease
	}

	.movie-recommend .movie-grid .movie-item .movie-card:active {
		-webkit-transform: scale(.98);
		transform: scale(.98);
		box-shadow: 2px 2px 6px rgba(0, 0, 0, .1), -1px -1px 4px hsla(0, 0%, 100%, .9)
	}

	.movie-recommend .movie-grid .movie-item .movie-card .movie-poster {
		position: relative;
		width: 100%;
		height: 166px;
		overflow: hidden
	}

	.movie-recommend .movie-grid .movie-item .movie-card .movie-poster img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		transition: -webkit-transform .3s ease;
		transition: transform .3s ease;
		transition: transform .3s ease, -webkit-transform .3s ease
	}

	.movie-recommend .movie-grid .movie-item .movie-card .movie-poster .movie-overlay {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, .3);
		display: flex;
		align-items: center;
		justify-content: center;
		opacity: 0;
		transition: opacity .3s ease
	}

	.movie-recommend .movie-grid .movie-item .movie-card .movie-poster .movie-overlay .play-btn {
		width: 41px;
		height: 41px;
		background: hsla(0, 0%, 100%, .95);
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: 0 2px 10px rgba(0, 0, 0, .3)
	}

	.movie-recommend .movie-grid .movie-item .movie-card .movie-poster .movie-overlay .play-btn .play-icon {
		font-size: 14px;
		color: #667eea;
		margin-left: 3px
	}

	.movie-recommend .movie-grid .movie-item .movie-card .movie-poster .movie-rank {
		position: absolute;
		top: 0;
		left: 0;
		background: linear-gradient(135deg, #ff6b6b, #ee5a6f);
		padding: 4px 8px;
		border-radius: 0 0 8px 0
	}

	.movie-recommend .movie-grid .movie-item .movie-card .movie-poster .movie-rank .rank-num {
		font-size: 10px;
		color: #fff;
		font-weight: 600
	}

	.movie-recommend .movie-grid .movie-item .movie-card:active .movie-poster img {
		-webkit-transform: scale(1.05);
		transform: scale(1.05)
	}

	.movie-recommend .movie-grid .movie-item .movie-card:active .movie-overlay {
		opacity: 1
	}

	.movie-recommend .movie-grid .movie-item .movie-card .movie-info {
		padding: 10px;
		min-width: 0
	}

	.movie-recommend .movie-grid .movie-item .movie-card .movie-info .movie-name {
		display: block;
		font-size: 14px;
		color: #333;
		font-weight: 600;
		margin-bottom: 6px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap
	}

	.movie-recommend .movie-grid .movie-item .movie-card .movie-info .movie-meta {
		display: flex;
		align-items: center;
		gap: 6px;
		min-width: 0;
		overflow: hidden
	}

	.movie-recommend .movie-grid .movie-item .movie-card .movie-info .movie-meta .meta-tag {
		font-size: 10px;
		color: #667eea;
		background: rgba(102, 126, 234, .1);
		padding: 2px 6px;
		border-radius: 4px;
		min-width: 0;
		max-width: 50%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap
	}

	.movie-recommend .movie-grid .movie-item .movie-card .movie-info .movie-meta .meta-hot {
		font-size: 10px;
		color: #ff6b6b;
		flex: 1;
		min-width: 0;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap
	}

	@-webkit-keyframes fadeInUp-data-v-1d8d274c {
		from {
			opacity: 0;
			-webkit-transform: translateY(15px);
			transform: translateY(15px)
		}

		to {
			opacity: 1;
			-webkit-transform: translateY(0);
			transform: translateY(0)
		}
	}

	@keyframes fadeInUp-data-v-1d8d274c {
		from {
			opacity: 0;
			-webkit-transform: translateY(15px);
			transform: translateY(15px)
		}

		to {
			opacity: 1;
			-webkit-transform: translateY(0);
			transform: translateY(0)
		}
	}

	.load-more-row {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 10px 0 4px
	}

	.load-more-text {
		font-size: 13px;
		color: #667eea;
		font-weight: 600;
		letter-spacing: 0.5px
	}
</style>
